import React, { useState } from 'react';
import {
  Accordion,
  Checkbox,
  Col,
  Row,
  Select,
  TextField,
} from '@folio/stripes-components';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { OnChange } from 'react-final-form-listeners';
import { FieldArray } from 'react-final-form-arrays';
import LocalizedTextField from '../../../../../../shared/LocalizedTextField';
import {
  composeValidators,
  required,
  validateEnglishOnly,
} from '../../../../../../utils/utils';
import RenderFieldDataOption from '../RenderFieldDataOption';
import styles from '../../styles.css';
import HelpeEditForm from '../../../../../../shared/HelpeEditForm';
import CategoryField from './CategoryField';
import {
  EntityTypes,
  FieldTypesOptions,
  SchemaTypes,
} from '../../../../../../constants';

function FormFields() {
  const [isRepeatable, setIsRepeatable] = useState(false);
  const [fieldDataType, setFieldDataType] = useState('');

  return (
    <div className={styles.form_container}>
      <OnChange name="isRepeatable">
        {(value) => {
          setIsRepeatable(value);
        }}
      </OnChange>
      <OnChange name="type">
        {(value) => {
          setFieldDataType(value);
        }}
      </OnChange>
      <Row>
        <Col xs={4}>
          <Field
            id="isRepeatable"
            name="isRepeatable"
            component={Checkbox}
            // checked={isRepeatable}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.customFields.editForm.formFields.isRepeatable"
                defaultMessage="Is repeatable"
              />
            }
            type="checkbox"
          />
        </Col>
        <Col xs={4}>
          <Field
            id="isRequired"
            name="isRequired"
            component={Checkbox}
            // checked={isRequired}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.customFields.editForm.formFields.isRequired"
                defaultMessage="Is required"
              />
            }
            type="checkbox"
          />
        </Col>
        <Col xs={4}>
          <Field
            id="canEdit"
            name="canEdit"
            component={Checkbox}
            // checked={canEdit}
            fullWidth
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.customFields.editForm.formFields.canEdit"
                defaultMessage="Can edit"
              />
            }
            type="checkbox"
          />
        </Col>
      </Row>
      <hr />
      <pr />
      <Row className={styles.row_container}>
        <Col xs={6}>
          <Row>
            <Col xs={12}>
              <CategoryField />
            </Col>
            <Col xs={12}>
              <FieldArray
                name="label"
                component={LocalizedTextField}
                fieldComponent={TextField}
                fieldLabel={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.customFields.editForm.formFields.label"
                    defaultMessage="Label"
                  />
                }
              />
            </Col>
            {isRepeatable && (
              <Col xs={12}>
                <FieldArray
                  name="singularLabel"
                  component={LocalizedTextField}
                  fieldComponent={TextField}
                  fieldLabel={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.customFields.editForm.formFields.singularLabel"
                      defaultMessage="Singular Label"
                    />
                  }
                />
              </Col>
            )}
            <Col xs={12}>
              <Field
                component={Select}
                fullWidth
                name="schema"
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.schema"
                    defaultMessage="Schema type"
                  />
                }
                dataOptions={SchemaTypes}
                required
                validate={required}
                type="text"
                disabled
              />
            </Col>
            <Col xs={12}>
              <Field
                component={Select}
                fullWidth
                name="entityType"
                label={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.entityType"
                    defaultMessage="Record type"
                  />
                }
                dataOptions={EntityTypes}
                required
                validate={required}
                type="text"
                // disabled
              />
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <HelpeEditForm />
        </Col>
      </Row>
      <Row className={styles.row_container}>
        <Col xs={6}>
          <Field
            component={TextField}
            fullWidth
            name="name"
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.customFields.editForm.formFields.fieldName"
                defaultMessage="Field name"
              />
            }
            required
            validate={composeValidators(required, validateEnglishOnly)}
            type="text"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={Select}
            fullWidth
            name="type"
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.customFields.editForm.formFields.fieldType"
                defaultMessage="Field type"
              />
            }
            dataOptions={FieldTypesOptions}
            required
            validate={required}
            type="text"
          />
        </Col>
      </Row>
      {fieldDataType === 'select' && (
        <Row className={styles.row_container}>
          <Col sm={12}>
            <Accordion
              id="custom-field-data-option}"
              label={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.customFieldsForm.fieldtypes.select.fieldDataOption"
                  defaultMessage="Field Data options"
                />
              }
              closedByDefault={false}
              separator
            >
              <FieldArray
                name="fieldDataOption"
                component={RenderFieldDataOption}
              />
            </Accordion>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default FormFields;
